/** Function that takes in a time as minutes and returns a human readable representation */
export default function getHumanReadableTime(minutes: number, abbreviateUnits?: boolean) {
	// Build unit format for minutes
	const minutesUnit = `min${abbreviateUnits ? '' : 'ute'}${minutes > 1 ? 's' : ''}`;
	
	
	// Handle zero minutes
	if (!minutes) {
		return `Less than a ${minutesUnit}`;
	}
	
	
	// Return formatted minutes if they are less than an hour
	if (minutes < 60) {
		return `${minutes} ${minutesUnit}`;
	}
	
	
	// Get hours and remaining minutes
	const hours = Math.floor(minutes / 60);
	const remainder = minutes % 60;
	
	
	// Build desired unit format
	const hourUnit = `h${abbreviateUnits ? '' : 'ou'}r${hours > 1 ? 's' : ''}`;
	const remainderUnit = `min${abbreviateUnits ? '' : 'ute'}${remainder > 1 ? 's' : ''}`;
	
	
	// Build human readable string
	let humanReadableTime = `${hours} ${hourUnit}`;
	
	if (remainder) {
		humanReadableTime = `${humanReadableTime} ${remainder} ${remainderUnit}`;
	}
	
	
	// Return
	return humanReadableTime;
}
